/* istanbul ignore file */

import { BasicDropdownValue } from '../basic-dropdown-value';

export class PresetStyleColorSelection extends BasicDropdownValue {
    class: string;
    isUsed = false;
}
